<template>
	<div v-if="serviceTerms && !serviceTerms.isApproved" class="service-dialog">
		<div class="wrapper">
			<div class="title">{{ localizer.get("PrivateArea.Common.ServiceTerms_Title") }}</div>
			<div class="abstract">{{ localizer.get("PrivateArea.Common.ServiceTerms_Abstract") }}</div>
			<div class="version">{{ serviceTerms.terms.title }} {{ serviceTerms.terms.version }}</div>
			<div v-html="serviceTerms.terms.description" class="desc"></div>
			<div class="bottom">
				<div class="cta">
					<div @click="setServiceTermsApproval()" class="button">{{ localizer.get("PrivateArea.Common.Accept") }}</div>
				</div>
				<div class="cta">
					<div @click="logout()" class="button" data-type="transparent">{{ localizer.get("PrivateArea.Common.Refuse") }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const isLoading = ref(false);
const serviceTerms = ref<any>(null);
const routes = (window as any).App.routes;

onMounted(async () => {
	await getServiceTermsData();
});

async function getServiceTermsData() {
	serviceTerms.value = (await Axios.post(routes.PrivateArea_Terms_GetServiceTermsData)).data;
}

async function setServiceTermsApproval() {
	isLoading.value = true;

	await Axios.post(routes.PrivateArea_Terms_SetServiceTermsApproval);

	await getServiceTermsData();

	isLoading.value = false;
}

async function logout() {
	localStorage.removeItem("token");

	await Axios.post(routes.Account_User_Logout, null);

	window.location.href = routes.Account_User_Login;
}
</script>